// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-wrapper{position:absolute;top:20px;left:0;right:0;display:flex;justify-content:center}.logo-frame{background:#fff;display:inline-block;border-top-left-radius:100%;border-top-right-radius:100%;border-bottom-left-radius:100%;border-bottom-right-radius:100%;overflow:hidden;border:3px solid #043654}", ""]);
// Exports
module.exports = exports;
